import toast from "react-hot-toast";
import * as api from "../Api";

export const getLocationItems = () => async (dispatch) => {
  try {
    const { data } = await api.locationItems();
    dispatch({ type: "LOCATION_ITEMS", payload: data });
  } catch (error) {}
};

export const updateLocationItem = (id, postData) => async (dispatch) => {
  try {
    const { data } = await api.updateLocationItem(id, postData);
    dispatch({ type: "UPDATE_LOCATION_ITEM", payload: data });
    toast.success("Item saved");
    return data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Couldn't save the item");
    throw error;
  }
};

export const deleteLocationItem = (id) => async (dispatch) => {
  try {
    await api.deleteLocationItem(id);
    dispatch({ type: "DELETE_LOCATION_ITEM", payload: id });
    toast.success("Item removed");
  } catch (error) {
    toast.error(error?.response?.data?.message || "Couldn't remove the item");
    throw error;
  }
};
